import styled from '@emotion/styled';

export const StyledWarningInfo = styled.div`
  background-color: ${({ theme }) => theme.palette?.brand.attention[300]};
  color: ${({ theme }) => theme.palette?.brand.attention[700]};
  border: 1px solid ${({ theme }) => theme.palette?.brand.attention[700]};
  border-radius: 10px;
  padding: 10px;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

export const StyledContent = styled.div`
  min-height: 20rem;
  margin-top: 5rem;
`;

export const StyledContainer = styled.div`
  padding: 2rem;
`;
